import httpClient from './httpClient';

export const fetchWeeklySummary = async (weekStart) => {
  const { data } = await httpClient.get('/admin/accounting/weekly-summary', { params: { weekStart } });
  return data;
};

export const confirmPayout = async (payload) => {
  const { data } = await httpClient.post('/admin/accounting/payouts', payload);
  return data;
};

export const fetchPayoutHistory = async () => {
  const { data } = await httpClient.get('/admin/accounting/payouts');
  return data;
};

export const deletePayout = async (id) => {
  await httpClient.delete(`/admin/accounting/payouts/${id}`);
};
